
import { getStorage, setStorage } from "../globals/storage";
import g from "../globals/variables";

const Cookies = {

  init: () => {
    if (getStorage("local", "s2aCookiesAccepted")) {
      g.el.cookies.classList.add("cookies--disabled");
    }

    g.el.cookies.querySelector(".button").addEventListener("click", Cookies.acceptCookies);
  },

  acceptCookies: () => {
    g.el.cookies.classList.add("cookies--hidden");
    setStorage("local", "s2aCookiesAccepted", true);
  },
};

export default Cookies;
